import {
  SHOW_FILTER_PANEL_TASKS,
  HIDE_FILTER_PANEL_TASKS,
  GET_ASSIGNEES_REQUEST,
  GET_ASSIGNEES_SUCCESS,
  GET_ASSIGNEES_FAILURE,
  GET_ASSIGNEES_INFINITE_REQUEST,
  GET_ASSIGNEES_INFINITE_SUCCESS,
  GET_ASSIGNEES_INFINITE_FAILURE
} from './filterPanelActionTypes';

export const showFilterPanelTasks = () => ({ type: SHOW_FILTER_PANEL_TASKS });

export const hideFilterPanelTasks = () => ({
  type: HIDE_FILTER_PANEL_TASKS
});

export const fetchAssigneesRequest = (queryParams) => ({
  type: GET_ASSIGNEES_REQUEST,
  queryParams
});

export const fetchAssigneesSuccess = (data) => ({
  type: GET_ASSIGNEES_SUCCESS,
  data
});

export const fetchAssigneesFailure = (error) => ({
  type: GET_ASSIGNEES_FAILURE,
  error
});

export const fetchAssigneesInfiniteRequest = (queryParams) => ({
  type: GET_ASSIGNEES_INFINITE_REQUEST,
  queryParams
});

export const fetchAssigneesInfiniteSuccess = (data) => ({
  type: GET_ASSIGNEES_INFINITE_SUCCESS,
  data
});

export const fetchAssigneesInfiniteFailure = (error) => ({
  type: GET_ASSIGNEES_INFINITE_FAILURE,
  error
});
